// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';

import './index.css';
import App from './App';
// eslint-disable-next-line
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
const appTag = document.getElementById('app-tag') || {};
appTag.className = document.location.hostname.split('.')[0];

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js